import { Link } from "@tanstack/react-router";
import { Mail, Phone, MapPin, MessageCircle, FileText, Instagram, Star } from "lucide-react";
import { Logo } from "./Logo";
import { contactInfo, socials } from "../lib/data";

const footerLinks = [
  { to: "/", label: "Home" },
  { to: "/diensten", label: "Diensten" },
  { to: "/werk-in-beeld", label: "Werk in beeld" },
  { to: "/subsidie", label: "Subsidie" },
  { to: "/kosten", label: "Kosten" },
  { to: "/timmerman-dordrecht", label: "Timmerman Dordrecht" },
  { to: "/over", label: "Over" },
  { to: "/contact", label: "Contact" },
];


export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border/60 bg-secondary/30">
      <div className="container-tight py-12 lg:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center">
              <Logo className="h-16 w-auto" />
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-muted-foreground">
              Veelzijdig timmer- en aannemersbedrijf uit Dordrecht, opgericht in 2018. Van dakkapel
              tot complete renovatie — alles ter plekke op maat gemaakt.
            </p>
            <a
              href={socials.instagram.href}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 rounded-md border border-input bg-background px-4 py-3 text-sm font-semibold text-foreground transition-colors hover:bg-accent"
            >
              <Instagram className="h-4 w-4 text-primary" aria-hidden="true" />
              Volg ons op Instagram
            </a>
            <a
              href={socials.google.href}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex items-center gap-2 rounded-md border border-input bg-background px-4 py-3 text-sm font-semibold text-foreground transition-colors hover:bg-accent md:ml-3"
            >
              <Star className="h-4 w-4 text-primary" aria-hidden="true" />
              Ons Google bedrijfsprofiel
            </a>
            <Link
              to="/voorwaarden"
              className="mt-3 inline-flex items-center gap-2 rounded-md border border-input bg-background px-4 py-3 text-sm font-semibold text-foreground transition-colors hover:bg-accent md:ml-3"
            >
              <FileText className="h-4 w-4 text-primary" aria-hidden="true" />
              Algemene leveringsvoorwaarden
            </Link>

          </div>


          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wide text-foreground">
              Navigatie
            </h3>
            <ul className="mt-4 space-y-1 md:space-y-2">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="block py-3 text-sm text-muted-foreground transition-colors hover:text-foreground md:inline md:py-0"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wide text-foreground">
              Contact
            </h3>
            <ul className="mt-4 space-y-1 md:space-y-3">
              <li>
                <a
                  href={contactInfo.adresHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 py-3 text-sm text-muted-foreground transition-colors hover:text-foreground md:py-0"
                >
                  <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
                  <span>{contactInfo.adres}</span>
                </a>
              </li>
              <li>
                <a
                  href={contactInfo.telefoonHref}
                  className="flex items-center gap-3 py-3 text-sm text-muted-foreground transition-colors hover:text-foreground md:py-0"
                >
                  <Phone className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
                  <span>{contactInfo.telefoon}</span>
                </a>
              </li>
              <li>
                <a
                  href={contactInfo.emailHref}
                  className="flex items-center gap-3 py-3 text-sm text-muted-foreground transition-colors hover:text-foreground md:py-0"
                >
                  <Mail className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
                  <span>{contactInfo.email}</span>
                </a>
              </li>
              <li>
                <a
                  href={contactInfo.whatsappHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 py-3 text-sm text-muted-foreground transition-colors hover:text-foreground md:py-0"
                >
                  <MessageCircle className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
                  <span>WhatsApp</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-border/60 pt-8 md:flex-row">
          <div className="text-center md:text-left">
            <p className="text-xs text-muted-foreground">
              © {currentYear} Fedor Timmerwerken. Alle rechten voorbehouden.
            </p>
            <p className="mt-1 text-[11px] text-muted-foreground/80">
              Website by{" "}
              <a
                href="https://www.klikmakers.site"
                target="_blank"
                rel="noopener noreferrer"
                className="underline-offset-2 transition-colors hover:text-foreground hover:underline"
              >
                Yamani Mondt
              </a>
            </p>
          </div>
          <p className="text-xs text-muted-foreground">Sterk in vakwerk, tot in elk detail.</p>
        </div>
      </div>
    </footer>
  );
}
